(function () {
  'use strict';

  function initOcrScanner(root) {
    if (!root || root.dataset.ogcOcrInitialised === 'true') return;
    root.dataset.ogcOcrInitialised = 'true';

    /* ── HERO LOAD-IN ── */
    var heroRevealEls = Array.prototype.slice.call(
      root.querySelectorAll('.hero [data-hero-reveal]')
    );

    var afterHeroEls = Array.prototype.slice.call(
      root.querySelectorAll('[data-after-hero]')
    );

    if (heroRevealEls.length || afterHeroEls.length) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        heroRevealEls.forEach(function (el) {
          el.classList.add('is-visible');
        });

        afterHeroEls.forEach(function (el) {
          el.classList.add('is-visible');
        });
      } else {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            heroRevealEls.forEach(function (el) {
              el.classList.add('is-visible');
            });
          });
        });

        // Reveal the highlights once the masthead sequence has finished.
        window.setTimeout(function () {
          afterHeroEls.forEach(function (el) {
            el.classList.add('is-visible');
          });
        }, 1150);

        // Hero fail-safe.
        window.setTimeout(function () {
          heroRevealEls.forEach(function (el) {
            el.classList.add('is-visible');
          });
        }, 1800);

        // Highlights fail-safe.
        window.setTimeout(function () {
          afterHeroEls.forEach(function (el) {
            el.classList.add('is-visible');
          });
        }, 2200);
      }
    }

    /* ── SCROLL REVEALS ── */

    var revealEls = Array.prototype.slice.call(
      root.querySelectorAll('[data-reveal]')
    );

    if (revealEls.length) {
      root.classList.add('ogc-reveal-ready');

      var prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (
        prefersReducedMotion ||
        !('IntersectionObserver' in window)
      ) {
        revealEls.forEach(function (el) {
          el.classList.add('is-visible');
        });
      } else {
        var revealObserver = new IntersectionObserver(
          function (entries, observer) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;

              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          },
          {
            threshold: 0.12,
            rootMargin: '0px 0px -8% 0px'
          }
        );

        revealEls.forEach(function (el) {
          revealObserver.observe(el);
        });

        // Fail-safe
        window.setTimeout(function () {
          revealEls.forEach(function (el) {
            var rect = el.getBoundingClientRect();

            if (
              rect.top < window.innerHeight * 0.92 &&
              rect.bottom > 0
            ) {
              el.classList.add('is-visible');
              revealObserver.unobserve(el);
            }
          });
        }, 800);
      }
    }

    /* ── TESTIMONIAL CAROUSEL ── */
    var carousel = root.querySelector('.testimonial-carousel');

    if (carousel) {
      var track = carousel.querySelector('.testimonial-scroll');
      var prev = carousel.querySelector('.tcard-nav.prev');
      var next = carousel.querySelector('.tcard-nav.next');

      if (track && prev && next) {
        function scrollAmount() {
          var card = track.firstElementChild;
          return card ? card.offsetWidth + 20 : track.clientWidth * 0.8;
        }

        function updateButtons() {
          var maxScroll = Math.max(
            0,
            track.scrollWidth - track.clientWidth - 1
          );

          prev.disabled = track.scrollLeft <= 1;
          next.disabled = track.scrollLeft >= maxScroll;
        }

        prev.addEventListener('click', function () {
          track.scrollBy({
            left: -scrollAmount(),
            behavior: 'smooth'
          });
        });

        next.addEventListener('click', function () {
          track.scrollBy({
            left: scrollAmount(),
            behavior: 'smooth'
          });
        });

        track.addEventListener('scroll', updateButtons, {
          passive: true
        });

        window.addEventListener('resize', updateButtons);

        updateButtons();
      }
    }

    /* ── LUCIDE ICONS ── */
    if (
      window.lucide &&
      typeof window.lucide.createIcons === 'function'
    ) {
      window.lucide.createIcons({
        attrs: {
          'aria-hidden': 'true'
        }
      });
    }
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll
      ? scope
      : document;

    if (
      context.matches &&
      context.matches('.ogc-ocr-scanner[data-section-id]')
    ) {
      initOcrScanner(context);
    }

    Array.prototype.forEach.call(
      context.querySelectorAll(
        '.ogc-ocr-scanner[data-section-id]'
      ),
      initOcrScanner
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Reinitialise when Shopify dynamically reloads the section.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();